import React, { useEffect, useState } from "react";
import axios from "axios";
import { getCurrentFY, getLastFYyears } from "../../../Utilitie";

import STAYardExFyearWise from "./STAYardExFyearWise";
import STAYardMWData from "./STAYardMWData";
import STATrafficFlow from "./STATrafficFlow";
import STATrafficFlowChart from "./STATrafficFlowChart";

const STATrafficFlowMaster = () => {
  const fys = getLastFYyears();
  const [data, setData] = useState([]);
  const [fyYears, setFyYears] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [selectedFy, setSelectedFy] = useState(
    getCurrentFY().replace("_", "-")
  );
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data: response } = await axios.get(
          `${urlPrefix}getAllStaTrafficFlow?FyYear=${selectedFy}`
        );

        if (response.status === "ok" && Array.isArray(response.data)) {
          setFyYears(response.previousFinancialYears);
          setData(response.data);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [selectedFy]);

  return (
    <div className="">
      <div class="d-flex justify-content-end ">
        <select
          className="form-select text-black fw-bolder text-center form-control w-25"
          onChange={(e) => {
            setSelectedFy(e.target.value);
          }}
        >
          <option value="" hidden>
            Select Financial Year
          </option>

          {fys.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>{" "}
      <div className="papaDiv ">
        <STATrafficFlowChart data={data} />
      </div>
      <div className="papaDiv ">
        <STATrafficFlow data={data} />
      </div>
      <div className="papaDiv "></div>
    </div>
  );
};
export default STATrafficFlowMaster;
